// extracted by mini-css-extract-plugin
export default {"wrapper":"ErrorPage_wrapper__bGKDx","title":"ErrorPage_title__bbGeI","description":"ErrorPage_description__KvqlZ","btnLink":"ErrorPage_btnLink__-dkvW"};